<template>
  <q-toolbar>
    <q-toolbar-title>
      <h6 class="text-primary">Pulse</h6>
    </q-toolbar-title>
    <q-btn
      color="primary"
      size="xs"
      dense
      fab-mini
      flat
      icon="refresh"
      label="Timing"
      @click="resetTimingParameters"
    >
      <q-tooltip>Reset parameters to default values</q-tooltip>
    </q-btn>
  </q-toolbar>
  <div
    class="q-gutter-xs q-pa-none"
  >
    <TimingParametersPulse />

    <q-toggle
      :dark="isDarkModeGlobal"
      type="checkbox"
      v-model="isSecondLevelTimingParameters"
      size="sm"
    >
      <h6 class="text-primary" >Pulse Train (PT)</h6>
      <q-tooltip>
        Show PT Timing Parameters
      </q-tooltip>
    </q-toggle>

    <TimingParametersTrain />

    <q-toggle
      :dark="isDarkModeGlobal"
      v-show="timingParameters && isSecondLevelTimingParameters"
      type="checkbox"
      v-model="isThirdLevelTimingParameters"
      size="sm"
    >
      <h6 class="text-primary">Pulse Train Repetition (PTR)</h6>
      <q-tooltip>
        Show PTR Timing Parameters
      </q-tooltip>
    </q-toggle>

    <TimingParametersTrainRepetition />
  </div>

</template>
<script setup lang="ts">
import TimingParametersPulse from "./TimingParametersPulse.vue";
import TimingParametersTrain from "./TimingParametersTrain.vue";
import TimingParametersTrainRepetition from "./TimingParametersTrainRepetition.vue";
import {storeToRefs} from "pinia";
import {useCalculatorStore} from '../stores/calculator.store'
import {watch} from "vue";
const calculatorStore = useCalculatorStore();
const {
  timingParameters,
  isSecondLevelTimingParameters,
  isThirdLevelTimingParameters,
  isDarkModeGlobal,
  pulse_duration_ms,
  pulse_train_duration_ms,
  importingData
} = storeToRefs(calculatorStore);

calculatorStore.initWorkers()

watch(isSecondLevelTimingParameters, (value) => {
  // if (importingData.value) return;

  // reset if toggled from true to false
  if (!value) resetTimingToFirstLevel()
  calculatorStore.showRecalculateButton()
})
watch(isThirdLevelTimingParameters, (value) => {
  // if (importingData.value) return;

  // reset if toggled from true to false
  if (!value) resetTimingToSecondLevel()
  calculatorStore.showRecalculateButton()

})

// Pulse Train Repetition Interval, Pulse train repetition duration equal Pulse Train Duration.
// Pulse Train Repetition Ramp duration is zero.
// Hide Ispta of pulse train repetition from results (non-derated and derated) and don't do the calculation to save time. Potentially add warning that calculation may take a time.
function resetTimingToSecondLevel() {
  calculatorStore.$patch({
    // PULSE PARAMETERS
        // PULSE TRAIN PARAMETERS
        pulse_train_repetition_interval_ms: pulse_train_duration_ms.value,

        // PULSE TRAIN REPETITION PARAMETERS
        pulse_train_repetition_duration_ms: pulse_train_duration_ms.value,
        pulse_train_repetition_ramp_duration_ms: 0,
        pulse_train_repetition_ramp_shape: "Tukey",
  })
}

// Pulse Repetition Interval, Pulse Train Duration, Pulse Train Repetition Interval, Pulse train repetition duration equal the pulse duration.
// Pulse Train Ramp duration and Pulse Train Repetition Ramp duration are zero.
// Hide both Ispta's from results (non-derated and derated) and don't do the calculations to save time.
function resetTimingToFirstLevel() {
  calculatorStore.$patch({
    // PULSE PARAMETERS
        pulse_repetition_interval_ms: pulse_duration_ms.value,

        // PULSE TRAIN PARAMETERS
        pulse_train_duration_ms: pulse_duration_ms.value,
        pulse_train_ramp_duration_ms: 0,
        pulse_train_ramp_shape: "Tukey",
        pulse_train_repetition_interval_ms: pulse_duration_ms.value,

        // PULSE TRAIN REPETITION PARAMETERS
        pulse_train_repetition_duration_ms: pulse_duration_ms.value,
        pulse_train_repetition_ramp_duration_ms: 0,
        pulse_train_repetition_ramp_shape: "Tukey",
        isThirdLevelTimingParameters: false
  })
}

function resetTimingParameters() {
  calculatorStore.$patch({
    // PULSE PARAMETERS
        pulse_duration_ms: 5,
        // percentage_of_pri: 100,
        percentage_of_pd: 0,
        // percentage_of_ptri: 100,
        percentage_pulse_train_repetition_ramp_width: 0,
        percentage_of_pulse_train_ramp_width: 0,
        pulse_ramp_duration_ms: 0,
        pulse_ramp_shape: "Tukey",
        pulse_repetition_interval_ms: 5,

        // PULSE TRAIN PARAMETERS
        pulse_train_duration_ms: 5,
        pulse_train_ramp_duration_ms: 0,
        pulse_train_ramp_shape: "Tukey",
        pulse_train_repetition_interval_ms: 5,

        // PULSE TRAIN REPETITION PARAMETERS
        pulse_train_repetition_duration_ms: 5,
        pulse_train_repetition_ramp_duration_ms: 0,
        pulse_train_repetition_ramp_shape: "Tukey",
        isThirdLevelTimingParameters: false,
        isSecondLevelTimingParameters: false,
  })
}
</script>